import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const greaterThanOrEqualTo = (greaterThanOrEqualControl: AbstractControl): ValidatorFn => {
  const key = 'greaterThanOrEqualTo';
  let subscribe = false;

  return (control: AbstractControl): ValidationErrors | null => {
    if (!subscribe) {
      subscribe = true;
      greaterThanOrEqualControl.valueChanges.subscribe(() => {
        control.updateValueAndValidity();
      });
    }

    const value = control.value;

    if (!value) return null;

    if (greaterThanOrEqualControl.value > value) return { [key]: true };

    return null;
  };
}
